module.exports = __webpack_public_path__ + "img/CM-SS-25-Volkswagen-Modern.9fc95b46.jpg";